/* StudioSoie · bannière de cookies maison (snippets/ss-cookie-banner.liquid) reliée à l'API Customer Privacy de Shopify.
   - Charge l'API (consent-tracking-api), n'affiche la bannière que si Shopify la demande (shouldShowBanner) ou sur demande ([data-ss-cookies-open]).
   - Enregistre le choix avec setTrackingConsent ; les apps et pixels Shopify respectent ce consentement.
   - L'état officiel vit dans les cookies de consentement gérés par Shopify. Filet de sécurité (11 oct. 2026) : le choix est aussi
     mémorisé 6 mois (localStorage + cookie first-party « ss_ck_choice ») ; si Shopify ne le retrouve pas sur une autre page
     (navigation privée, ITP Safari, etc.), il est ré-appliqué en silence au lieu de redemander. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss-cookies]');
  if (!root) { return; }
  var prefs = root.querySelector('[data-ss-ck-prefs]'), btnAccept = root.querySelector('[data-ss-ck-accept]'), btnDecline = root.querySelector('[data-ss-ck-decline]'),
      btnSave = root.querySelector('[data-ss-ck-save]'), btnCustom = root.querySelector('[data-ss-ck-customize]');
  var api = null, apiLoading = null, lastFocus = null;
  var KEY = 'ss_ck_choice', MAXAGE = 182 * 24 * 3600 * 1000;
  function saveChoice(p) {
    var v = JSON.stringify({ a: p.analytics ? 1 : 0, m: p.marketing ? 1 : 0, p: p.preferences ? 1 : 0, t: Date.now() });
    try { localStorage.setItem(KEY, v); } catch (e) {}
    try { document.cookie = KEY + '=' + encodeURIComponent(v) + ';path=/;max-age=15724800;SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : ''); } catch (e) {}
  }
  function readChoice() {
    var v = null;
    try { v = localStorage.getItem(KEY); } catch (e) {}
    if (!v) { var m = document.cookie.match(/(?:^|; )ss_ck_choice=([^;]*)/); if (m) { try { v = decodeURIComponent(m[1]); } catch (e) {} } }
    if (!v) { return null; }
    try { var o = JSON.parse(v); if (!o || !o.t || Date.now() - o.t > MAXAGE) { return null; } return { analytics: !!o.a, marketing: !!o.m, preferences: !!o.p }; } catch (e) { return null; }
  }

  function loadApi() {
    if (api) { return Promise.resolve(api); }
    if (apiLoading) { return apiLoading; }
    apiLoading = new Promise(function (resolve) {
      var done = function () { api = (window.Shopify && window.Shopify.customerPrivacy) || null; resolve(api); };
      if (window.Shopify && window.Shopify.customerPrivacy) { return done(); }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err) { resolve(null); } else { done(); } }); } catch (e) { resolve(null); }
        setTimeout(function () { resolve((window.Shopify && window.Shopify.customerPrivacy) || null); }, 6000);
      } else { resolve(null); }
    });
    return apiLoading;
  }

  /* Ne pas recouvrir la barre d'achat collante des fiches produit (Booster) ni le lanceur du chat : on remonte la bannière */
  var isModal = root.getAttribute('data-position') === 'modal';
  function placeAbove() {
    var lift = 0;
    if (isModal) { return; }
    document.querySelectorAll('.product-page-sticky--atc, [data-sticky-atc], .sticky-atc').forEach(function (el) {
      var r = el.getBoundingClientRect(); var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || r.height < 20 || r.bottom < window.innerHeight - 40) { return; }
      var mine = root.getBoundingClientRect();
      var overlapX = mine.width === 0 || (r.left < mine.right && r.right > mine.left);
      if (overlapX) { lift = Math.max(lift, window.innerHeight - r.top + 12); }
    });
    root.style.bottom = lift ? lift + 'px' : '';
  }
  function show(customize) {
    lastFocus = document.activeElement;
    root.hidden = false;
    if (isModal) { document.documentElement.classList.add('ss-ck-lock'); }
    placeAbove();
    window.addEventListener('resize', placeAbove, { passive: true });
    window.addEventListener('scroll', placeAbove, { passive: true });
    requestAnimationFrame(function () { root.classList.add('is-shown'); });
    if (customize) { openPrefs(); }
    try { (customize ? prefs.querySelector('input') : btnAccept).focus({ preventScroll: true }); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ss:cookies:shown'));
  }
  function hide() {
    root.classList.remove('is-shown');
    document.documentElement.classList.remove('ss-ck-lock');
    setTimeout(function () { root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openPrefs() {
    prefs.hidden = false; btnSave.hidden = false; btnCustom.hidden = true; btnCustom.setAttribute('aria-expanded', 'true'); root.classList.add('is-custom');
  }
  function closePrefs() {
    prefs.hidden = true; btnSave.hidden = true; btnCustom.hidden = false; btnCustom.setAttribute('aria-expanded', 'false'); root.classList.remove('is-custom');
  }
  function syncFromCurrent() {
    if (!api || typeof api.currentVisitorConsent !== 'function') { return; }
    try {
      var c = api.currentVisitorConsent() || {};
      root.querySelectorAll('[data-ss-ck]').forEach(function (inp) { var v = c[inp.getAttribute('data-ss-ck')]; if (v === 'yes' || v === 'no') { inp.checked = v === 'yes'; } });
    } catch (e) {}
  }
  function consent(values) {
    var payload = { analytics: !!values.analytics, marketing: !!values.marketing, preferences: !!values.preferences, sale_of_data: !!values.marketing };
    saveChoice(payload);
    var finish = function () {
      hide();
      document.dispatchEvent(new CustomEvent('ss:cookies:consent', { detail: payload }));
      /* le thème : les scripts qui attendaient le consentement (Suivi & pixels) écoutent cet événement */
    };
    loadApi().then(function (a) {
      if (a && typeof a.setTrackingConsent === 'function') {
        var cb = function () { finish(); };
        try { a.setTrackingConsent({ analytics: payload.analytics, marketing: payload.marketing, preferences: payload.preferences, sale_of_data: payload.sale_of_data }, cb); } catch (e) { finish(); }
      } else { finish(); }
    });
  }

  btnAccept.addEventListener('click', function () { consent({ analytics: true, marketing: true, preferences: true }); });
  btnDecline.addEventListener('click', function () { consent({ analytics: false, marketing: false, preferences: false }); });
  btnSave.addEventListener('click', function () {
    var v = {}; root.querySelectorAll('[data-ss-ck]').forEach(function (inp) { v[inp.getAttribute('data-ss-ck')] = inp.checked; });
    consent(v);
  });
  btnCustom.addEventListener('click', function () { if (prefs.hidden) { openPrefs(); } else { closePrefs(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden && root.classList.contains('is-custom')) { closePrefs(); } });

  /* Réouverture depuis le pied de page (ou tout lien data-ss-cookies-open / #shopifyReshowConsentBanner) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ss-cookies-open], a[href*="shopifyReshowConsentBanner"]');
    if (!a) { return; }
    e.preventDefault();
    document.documentElement.classList.add('ss-ck-on');
    loadApi().then(function () { syncFromCurrent(); show(true); });
  });
  window.SSCookies = { open: function () { loadApi().then(function () { syncFromCurrent(); show(true); }); }, close: hide };

  /* Affichage initial (run 8) : la bannière StudioSoie remplace celle de Shopify.
     - On l'affiche si l'API demande un consentement (shouldShowBanner) OU si Shopify insère sa bannière native (#shopify-pc__banner),
       sauf si le visiteur a déjà fait un choix.
     - Quand la nôtre est affichée, la classe html.ss-ck-on masque la bannière native (CSS) : un seul choix, enregistré par la même API.
       Si ce script ne se charge pas, la bannière native reste visible (secours). */
  /* 14 oct. 2026 : Shopify renvoie désormais « no » (et plus « ») pour un visiteur européen qui n'a encore RIEN choisi.
     L'ancien test (« yes » ou « no » = déjà décidé) croyait donc que tout le monde avait déjà répondu : notre bannière ne s'affichait plus,
     la bannière native restait masquée → aucun consentement en Europe (statistiques et pixels publicitaires coupés).
     La référence est maintenant shouldShowBanner() : tant que Shopify demande une bannière, le choix n'est pas fait. */
  function decided(a) {
    try { if (a && typeof a.shouldShowBanner === 'function') { return !a.shouldShowBanner(); } } catch (e) {}
    try { var c = a.currentVisitorConsent ? a.currentVisitorConsent() : null; if (!c) { return false; } return ['analytics', 'marketing', 'preferences'].some(function (k) { return c[k] === 'yes'; }); } catch (e) { return false; }
  }
  var shown0 = false;
  function takeOver(a) {
    if (shown0 || (a && decided(a))) { return; }
    var prev = readChoice();
    if (prev && a && typeof a.setTrackingConsent === 'function') {
      /* choix déjà fait (sur une autre page) mais pas retrouvé par Shopify : on le ré-applique sans redemander */
      shown0 = true;
      try { a.setTrackingConsent({ analytics: prev.analytics, marketing: prev.marketing, preferences: prev.preferences, sale_of_data: prev.marketing }, function () { document.dispatchEvent(new CustomEvent('ss:cookies:consent', { detail: prev })); }); } catch (e) {}
      return;
    }
    shown0 = true; document.documentElement.classList.add('ss-ck-on');
    syncFromCurrent(); setTimeout(function () { show(false); }, 300);
  }
  function init() {
    loadApi().then(function (a) {
      var need = false;
      if (a && typeof a.shouldShowBanner === 'function') { try { need = a.shouldShowBanner(); } catch (e) { need = false; } }
      if (need) { takeOver(a); return; }
      if (document.getElementById('shopify-pc__banner')) { takeOver(a); return; }
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (document.getElementById('shopify-pc__banner')) { mo.disconnect(); takeOver(a); } });
        mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 15000);
      }
    });
  }
  if (document.readyState === 'complete') { init(); } else { window.addEventListener('load', init, { once: true }); }
})();
